import classnames from 'classnames'
import {css} from 'emotion'
import * as React from 'react'
import styles from './styles.module.css'

export interface IDSInlineColorSwatchProps {
  /** Any CSS color: hex, rgb(), a `var(--…)` token, etc. */
  'color': string
  /** When set, the swatch is announced with this text; otherwise it is decorative. */
  'aria-label'?: string
  'className'?: string
}

/**
 * A small rounded-square color chip sized in `em`, so it matches whatever text
 * it sits inside (a `DSText`, a button label, …) and flows inline with it.
 */
const DSInlineColorSwatch = ({
  color,
  'aria-label': ariaLabel,
  className,
}: IDSInlineColorSwatchProps) => (
  <span
    role={ariaLabel === undefined ? undefined : 'img'}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel === undefined ? true : undefined}
    className={classnames(
      styles.swatch,
      css`
        background-color: ${color};
      `,
      className
    )}
  />
)

export default DSInlineColorSwatch
